import { signUpUrl } from '../../../Container/App'
import Index from '../../../Assets/Images/Index'
import Fade from 'react-reveal/Fade';
import { NavLink } from 'react-router-dom';
import { Accordion } from 'react-bootstrap';

const PricingBoxBoxData = [
    {
        title: "Standard",
        mosttpopular: false,
        // content: "Launch a more professional and feature-packed online store with this plan and get meaningful data insights to make improvements.",
        pricing: 999,
        list: [
            "200 Products",
            "Online Store",
            "Staff Access (2)",
            "Blog Pages",
            "Discount Codes",
            "Basic Reporting",
            "1GB File Storage",
            "Manual Order Creation",
            "Free SSL Certificate",
            "Basic Customer Support",
        ]
    },
    {
        title: "Professional",
        mosttpopular: true,
        // content: "Uplift your ecommerce business with our power-packed advanced monthly plan meeting all your online business requirements.",
        pricing: 1799,
        list: [
            "Unlimited Products",
            "Online Store",
            "Staff Access (5)",
            "Blog Pages",
            "Discount Codes",
            "Advanced Reporting",
            "Unlimited File Storage",
            "Manual Order Creation",
            "Free SSL Certificate",
            "24/5 Customer Support",
        ]
    },
]

const questionAnswer = [
    {
        question: "How can I get payments?",
        answer: "Your customers can choose how they want to pay you, for example, Cash on delivery, Stripe, Razorpay, etc.",
    },
    {
        question: "Do I  require a Credit card for a free trial?",
        answer: "No, you can sign up for the 15 days free trial without the need to enter the details of your credit card.",
    },
    {
        question: "Is there any setup cost?",
        answer: "No, you will not be charged any set-up cost for any of the above plans.",
    },
    {
        question: "Do I have to pay extra charges for customized Shopyxa store hosting? ",
        answer: "No, the total cost of the plans includes the domain charges. You don't have to pay any extra amount for hosting.",
    },
    {
        question: "Can I use my own domain name with Shopyxa?",
        answer: "Yes, you can use your existing domain name on Shopyxa if you want. Also, you can avail of a new one if needed.",
    },

]

const onePlatform = [

    {
        img: Index.featureIcon3,
        title: "24*5 Tech Support",
        content: "We can help you solve your queries and issues when designing your store. We are available to serve you around the clock."
    },
    {
        img: Index.featureIcon2,
        title: "Multiple Payment Gateways",
        content: "Your customers have flexible payment options when buying from your stores. So, there are no payment barriers between you both."
    },
    {
        img: Index.featureIcon1,
        title: "Mobile Managed Stores",
        content: "Above two plans allow you to build mobile responsive stores and you can manage your stores from your smartphones."
    },

]

export default function Pricing() {
    return (
        <main>
            <section className="pricing commonPY">
                <div className="container">
                    <div className="headingText text-center mb-5">
                        <h2>Customized Shopyxa Plans Tailored For <br />Your Needs Starting From <span>₹17/day</span></h2>
                        <p>Best Online Store Platform for Small Business</p>
                    </div>
                    <div className="pricingInner">
                        {PricingBoxBoxData.map((data, indx) => {
                            return (
                                <Fade up key={indx} delay={indx * 200}>
                                    <div className={`pricingBox ${data.mosttpopular ? "most-popular" : ""}`}>
                                        <div className="pricingBox__head">
                                            {data.mosttpopular ? <div className="most-popular-badge"><span className="badge">Most Popular</span></div> : null}
                                            {/* <div className='offer_badge' style={{ backgroundColor: !data.mosttpopular ? "#029377" : "#c3451e" }}>50% Off</div> */}
                                            {data.mosttpopular ?
                                                <h3>{data.title}</h3>
                                                :
                                                <div className="badgeWrap"><span className="badge">{data.title}</span></div>
                                            }
                                            <h2 className='plans_price'>
                                                <del className='h4 m-0 mx-2'>₹<span>{(data.pricing).toLocaleString()}</span></del>
                                                <span className="price">₹{parseInt(data.pricing / 2).toLocaleString()}</span>
                                                <sup><small>+GST</small></sup>
                                                {/* <div className="small-text">per month</div> */}
                                            </h2>
                                            <h6>Billed monthly</h6>
                                        </div>
                                        <div className="pricingBox__body">
                                            {data.content && <p>data.content</p>}
                                            <ul>
                                                {data.list.map((cntnt, ind) => {
                                                    return (
                                                        <li key={ind}>{cntnt}</li>
                                                    )
                                                })}
                                            </ul>
                                        </div>
                                        <div className="pricingBox__foot">
                                            <a className="commonButton primary wide" href={signUpUrl}>Start Free Trial</a>
                                        </div>
                                    </div>
                                </Fade>
                            )
                        })}
                        <Fade up delay={300}>
                            <div className="pricingBox">
                                <div className="pricingBox__head">
                                    <div className="badgeWrap"><span className="badge">Enterprise</span></div>
                                    <h3>Let's Discuss</h3>
                                    <h6>Custom pricing</h6>
                                </div>
                                <div className="pricingBox__body">
                                    <ul>
                                        <li>Everything in Professional</li>
                                        <li>Dedicated Manager</li>
                                        <li>Custom Integrations</li>
                                        <li>Priority Support</li>
                                        <li>Advanced Security</li>
                                    </ul>
                                </div>
                                <div className="pricingBox__foot">
                                    <NavLink className="commonButton wide" to="/contact">Contact Us</NavLink>
                                </div>
                            </div>
                        </Fade>
                    </div>
                </div>
            </section>

            <section className="whyShopyxa gradientBg commonPY">
                <div className="container">
                    <Fade up>
                        <div className="headingText mb-5">
                            <h2>All Plans Include <span>The Following:</span></h2>
                        </div>
                    </Fade>
                    <div className="shopyxaFeatures">
                        <div className="row">
                            {onePlatform.map((item, index) => {
                                return (
                                    <div className="col-md-6 col-lg-4" key={index}>
                                        <div className="featuresGrid">
                                            <div className="featuresIcon"><img src={item.img} alt="" /></div>
                                            <h4>{item.title}</h4>
                                            <p>{item.content}</p>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </div>
            </section>

            <section className="faq commonPY">
                <div className="container">
                    <div className="headingText text-center mb-5">
                        <h2>Still Have Any <span>Questions</span></h2>
                    </div>
                    <div className="faqAccordionBlock">
                        <Fade up>
                            <Accordion defaultActiveKey="0">
                                {questionAnswer.map((data, indx) => {
                                    return (
                                        <Accordion.Item eventKey={indx} key={indx} className='faqAccordion'>
                                            <Accordion.Header className='h4'>{data.question}</Accordion.Header>
                                            <Accordion.Body>{data.answer}</Accordion.Body>
                                        </Accordion.Item>
                                    )
                                })}
                            </Accordion>
                        </Fade>

                    </div>
                </div>
            </section>

            <section className="cta commonPB">
                <div className="container">
                    <div className="ctaInner">
                        <div className="headingText white parallax delay-1">
                            <h2>Start Free Product Selling On Shopyxa</h2>
                            <h5>Best Online Store Platform for Small Business</h5>
                        </div>
                        <div className="buttonOuter parallax delay-3">
                            <a className="commonButton outline" href={signUpUrl}>Start Free Trial</a>
                        </div>
                    </div>
                </div>
            </section>

        </main>
    )
}
